import { render, staticRenderFns } from "./chezhu-login.vue?vue&type=template&id=86b01148&scoped=true&"
import script from "./chezhu-login.vue?vue&type=script&lang=js&"
export * from "./chezhu-login.vue?vue&type=script&lang=js&"
import style0 from "./chezhu-login.vue?vue&type=style&index=0&id=86b01148&lang=scss&scoped=true&"
import style1 from "./chezhu-login.vue?vue&type=style&index=1&id=86b01148&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "86b01148",
  null
  
)

export default component.exports